import React, { FC } from "react"

interface IProps {
  title?: string
  value?: any
  onChange?: any
  onBlur?: any
  placeholder?: string
  disabled?: boolean
  id?: string
  name?: string
  type?: string
  invalid?: boolean
  altLabelOne?: string
  altLabelTwo?: string
  altLabelThree?: string
  wide?: boolean
  required?: boolean
  hint?: string
}

export const InputField: FC<IProps> = (props) => {
  const {
    title,
    value,
    onChange,
    onBlur,
    placeholder,
    disabled,
    id,
    name,
    type,
    invalid,
    altLabelOne,
    altLabelTwo,
    altLabelThree,
    wide,
    required,
    hint
  } = props
  return (
    <div className="w-full form-control">
      <label className="label">
        <span className={`label-text ${invalid ? "text-error" : ""}`}>{title}</span>
        <span className={`label-text-alt ${invalid ? "text-error" : ""}`}>{altLabelOne}</span>
      </label>
      <input
        type={type || "text"}
        value={value}
        required={required}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        className={`w-full input input-bordered bg-[rgba(0,0,0,0.05)] dark:bg-[rgba(0,0,0,0.2)] ${invalid ? "input-error" : ""} ${
          wide && "h-24"
        }`}
        disabled={disabled}
        {...(id && { id })}
        {...(name && { name })}
      />
      <label>
        <span className={`label-text-alt ${invalid ? "text-error" : ""}`}>{altLabelTwo}</span>
        <span className={`label-text-alt ${invalid ? "text-error" : ""}`}>{altLabelThree}</span>
      </label>
      {hint && (
        <label className="label">
          <span className={`label-text-alt ${invalid ? "text-error" : ""}`}>{hint}</span>
        </label>
      )}
    </div>
  )
}
